import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';

import Button from 'jbc-front/components/Button';
import CommonModal from 'jbc-front/components/CommonModal';
import { ErrorsSection } from 'src/components';
import { FormSubmitBtn } from 'src/buttons';
import { EMPLOYEE_PAY_ALL_ROLLBACK_FORM } from 'src/constants/FormNames';
import { allRollbackEmployeePay, REDUCER_NAME } from 'src/reducers/employees/employeePays';
import { getItemErrors } from 'src/reducers/common/itemReducer';
import { getSelectOptions } from 'src/reducers/selectOptions';
import styles from './AllRollbackEmployeePayModal.scss';
import { useTranslation } from 'react-i18next';

const AllRollbackEmployeePayInsideForm = ({
  submitting,
  submit,
  cancelBtnClick,
  errors,
  header,
  yearMonth,
  uniquePaymentDates
}) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form className={styles.wrap}>
          <ErrorsSection errors={errors} />
          <div>
            {_.get(_.find(uniquePaymentDates, { value: yearMonth }), 'label')}{t('features.EmployeePays.components.AllRollbackEmployeePayModal.Back_to_before_manual_input_for_all_subjects_for_salary')}
          </div>
          <ul className={styles.notes}>
            <li>
              {t('features.EmployeePays.components.AllRollbackEmployeePayModal.Value_manually_input_and_value_input_by_CSV_will_be_deleted_and_replaced_by_value_automatically_calculated_from_the_current_setting')}
            </li>
          </ul>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelBtnClick} className="u-mr20">
          {t('features.EmployeeBonus.components.ActionButtonSection.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.AllRollbackEmployeePayModal.Execute')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </React.Fragment>
  );
};

let AllRollbakcEmployeePayForm = reduxForm({
  form: EMPLOYEE_PAY_ALL_ROLLBACK_FORM
})(AllRollbackEmployeePayInsideForm);

const mapStateToProp = state => ({
  errors: getItemErrors(REDUCER_NAME, state).rollbackEmployeePay,
  uniquePaymentDates: getSelectOptions(state, 'uniquePaymentDates')
});
const mapDispatchToProp = (dispatch, ownProps) => ({
  onSubmit: () => dispatch(allRollbackEmployeePay(ownProps.payrollRulesGroups, ownProps.yearMonth))
});

AllRollbakcEmployeePayForm = connect(mapStateToProp, mapDispatchToProp)(AllRollbakcEmployeePayForm);

const AllRollbackEmployeePayModal = ({ isOpen, hideModal, payrollRulesGroups, yearMonth }) => {
  const { t } = useTranslation();
  const header = t('features.EmployeePays.components.AllRollbackEmployeePayModal.Back_to_before_manual_input_for_all');
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <AllRollbakcEmployeePayForm
        cancelBtnClick={hideModal}
        header={header}
        payrollRulesGroups={payrollRulesGroups}
        yearMonth={yearMonth}
      />
    </CommonModal>
  );
};

export default connect()(AllRollbackEmployeePayModal);
